module.exports = __webpack_public_path__ + "static/media/Milk_lite7.1c916429.jpg";